var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcButton',{attrs:{"type":"success"},on:{"click":_vm.disableLobby},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('LockOpen')]},proxy:true}])},[_vm._v("\n\t"+_vm._s(_vm.t('spreed', 'Disable lobby' ))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }